import validate from "/home/runner/work/rediredi-storefront/rediredi-storefront/node_modules/nuxt/dist/pages/runtime/validate.js";
import routes_45global from "/home/runner/work/rediredi-storefront/rediredi-storefront/middleware/routes.global.ts";
export const globalMiddleware = [
  validate,
  routes_45global
]
export const namedMiddleware = {}